// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_gateway__ZCLZz {
  margin: 2rem 0rem; }

.styles_emptyCard__F9JIx {
  border-style: dashed;
  padding: 0rem 2rem; }

.styles_container__tJWHd .styles_initCard__lZu\\+Y button {
  height: 100%;
  width: 100%;
  display: flex;
  border: 1px dashed grey;
  justify-content: center;
  align-items: center;
  margin: 1rem 0rem;
  padding: 1.5rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/cycles/components/Cycle/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,iBAAiB,EAAA;;AAGnB;EACE,oBAAoB;EACpB,kBAAkB,EAAA;;AAGpB;EAEI,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe,EAAA","sourcesContent":[".gateway {\n  margin: 2rem 0rem;\n}\n\n.emptyCard {\n  border-style: dashed;\n  padding: 0rem 2rem;\n}\n\n.container {\n  .initCard button {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    border: 1px dashed grey;\n    justify-content: center;\n    align-items: center;\n    margin: 1rem 0rem;\n    padding: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gateway": `styles_gateway__ZCLZz`,
	"emptyCard": `styles_emptyCard__F9JIx`,
	"container": `styles_container__tJWHd`,
	"initCard": `styles_initCard__lZu+Y`
};
export default ___CSS_LOADER_EXPORT___;
